import { createEntityReducer } from 'util/reducers'

export default createEntityReducer('companies', {
  transformEntity: company => {
    const newCompany = { ...company }
    if (newCompany.customFieldValues && newCompany.customFieldValues.nodes) {
      newCompany.customFieldValues = newCompany.customFieldValues.nodes.reduce(
        (result, fieldValue) => {
          const {
            key: valueKey, // This is actually the custom field key but sometimes it is on the value
            customField: { isArray, key = valueKey } = {},
            ...rest
          } = fieldValue
          const existingValue = result[key]
          if (isArray) {
            rest.value = [...(existingValue?.value || []), rest.value]
          }
          // eslint-disable-next-line no-param-reassign
          result[key] = { key, ...rest }
          return result
        },
        {}
      )
    }
    return newCompany
  },
})
